<template>
  <rs-select
    :label="label"
    :items="options"
    v-bind="$attrs"
    v-on="$listeners"
    hide-details="auto"
    @change="handleChange"
    custom-item
    :loading="isLoading"
  >
    <template v-slot:item="data">
      <v-list-item-content v-if="!admin">
        <v-list-item-title>{{ data.item.name }}</v-list-item-title>
        <v-list-item-subtitle>
          <!-- {{ getExpenseName(data.item) }} -->
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-content v-else>
        <v-list-item-title>{{ data.item.name }}</v-list-item-title>
        <v-list-item-subtitle>
          <template v-if="data.item.customer_name">
            <strong>{{ data.item.customer_name }}</strong> |
          </template>
          <template v-else><em>Müşteri yok</em> | </template>
          {{ data.item.is_active ? "Aktif" : "Pasif" }} |
          {{ data.item.house_count }} BB | VKN/TCKN: {{ data.item.tax_number }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </rs-select>
</template>

<script>
import { mapGetters } from "vuex";

import { hasPermissions } from "@/view/mixins";

export default {
  name: "SelectCluster",
  props: {
    companyId: {
      type: Number,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: "TYA Seçin",
    },
    searchParams: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    admin: {
      type: Boolean,
      required: false,
      default: false,
    },
    customerRelationDate: {
      type: String,
      required: false,
      default: null,
    },
    useCustomerRelation: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [hasPermissions],
  computed: {
    ...mapGetters(["clusterId"]),
  },
  watch: {
    companyId() {
      this.loadList();
    },
    customerRelationDate() {
      this.loadList();
    },
    searchParams: {
      deep: true,
      handler() {
        this.loadList();
      },
    },
  },
  data() {
    return {
      options: [],
      isLoading: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.loadList();
    });
  },
  methods: {
    loadList() {
      const usesCustomerRelation =
        this.useCustomerRelation &&
        !!this.searchParams &&
        !!this.searchParams.customer_id;

      if (usesCustomerRelation && !this.customerRelationDate) {
        this.options = [];
        this.isLoading = false;
        return;
      }

      const params = Object.assign(
        usesCustomerRelation
          ? { per_page: 1000, page: 1, order_by: "cluster_name", order: "asc" }
          : { per_page: 1000, order_by: "name", order: "asc" },
        this.searchParams
      );

      if (usesCustomerRelation) {
        params.effective_on = this.customerRelationDate;
      }

      if (this.companyId) {
        params.company_id = this.companyId;
      }
      this.options = [];
      this.isLoading = true;

      let url = "clusters";

      if (this.admin) {
        url = "api-super-admin/clusters";
      }

      if (usesCustomerRelation) {
        url = "api-super-admin/customer-clusters";
      }

      this.$api
        .query(url, { params })
        .then((response) => {
          if (response.data.data) {
            this.options = usesCustomerRelation
              ? response.data.data.map((item) => ({
                  id: item.cluster_id,
                  name: item.cluster_name,
                  house_count: item.house_count,
                  customer_cluster_id: item.id,
                  cluster_id: item.cluster_id,
                  customer_id: item.customer_id,
                  starts_on: item.starts_on,
                  ends_on: item.ends_on,
                  is_active: item.cluster_is_active,
                }))
              : response.data.data;
          } else {
            throw new Error("Clusters not retrieved");
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        })
        .finally(() => (this.isLoading = false));
    },
    handleChange(id) {
      for (const index in this.options) {
        if (id === this.options[index].id) {
          this.$emit("change:item", this.options[index]);
          return;
        }
      }
      this.$emit("change:item", null);
    },
  },
};
</script>
